/**
 * Queue domain — the ordered list of tracks scheduled for playback.
 */
import { z } from "zod";
export const QueueEntrySchema = z.object({
    id: z.number().int().nonnegative(),
    /** Server-side library filename (required for client media URLs). */
    filename: z.string().min(1),
    title: z.string(),
    artist: z.string().nullable(),
    owner: z.string(),
    durationSec: z.number().positive().nullable().optional(),
    /** Seconds from "now" until this entry starts. null if already played. */
    timeUntilPlay: z.number().nonnegative().nullable().optional(),
});
export const QueueInputEntrySchema = z.object({
    id: z.number().int().nonnegative(),
    durationSec: z.number().positive().optional(),
});
export const PutQueueBodySchema = z.object({
    queue: z.array(QueueInputEntrySchema),
    currentIndex: z.number().int().nonnegative().optional(),
    currentTime: z.number().nonnegative().optional(),
});
//# sourceMappingURL=queue.js.map